import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import SiteChrome from './SiteChrome';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Verifying your email address...');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmailToken = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('');
        setError('This verification link is missing a token.');
        return;
      }

      try {
        await api.verifyEmail(token);
        setStatus('Your email has been verified. You can now sign in to your affiliate dashboard.');
      } catch (err) {
        setStatus('');
        setError(err.message || 'Email verification failed. Please request a new verification email from the app.');
      }
    };

    verifyEmailToken();
  }, [searchParams]);

  return (
    <SiteChrome>
      <div className="max-w-md mx-auto px-5 sm:px-6 py-10 sm:py-12">
        <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-8 text-center">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Verify Email</h1>

          {status && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <p className="text-green-800 text-sm">{status}</p>
            </div>
          )}

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-red-800 text-sm">{error}</p>
            </div>
          )}

          <Link
            to="/login"
            className="inline-flex items-center justify-center bg-primary-600 hover:bg-primary-700 text-white text-sm px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            Go to Login
          </Link>
        </div>
      </div>
    </SiteChrome>
  );
};

export default VerifyEmail;
